import React, {PureComponent, KeyboardEvent, ChangeEvent, CSSProperties} from 'react'
import TinyDatePicker from 'tiny-date-picker'
import './DatePicker.css'
import cxs from 'cxs/component'
import Theme, {mediaQueries} from 'Theme'
import {lang} from 'helpers/i18n'
import {Input} from 'elements'

interface Props {
  name: string
  date?: Date
  withTime?: boolean
  onChange(date: string, value: Date): void
  onKeyPress?(charCode: number): void
}

interface State {
  date: Date
  hour: number
  minutes: number
}

export default class extends PureComponent<Props, State> {
  id = `datepicker-${this.props.name}`
  picker
  state: State

  constructor(props: Props) {
    super(props)
    const date =
      props.date && typeof props.date === 'string'
        ? new Date(props.date)
        : props.date || new Date()
    this.state = {
      date,
      hour: date.getHours(),
      minutes: date.getMinutes()
    }
    console.log(this.id)
  }

  componentDidMount() {
    this.picker = TinyDatePicker(document.getElementById(this.id), {
      mode: 'dp-permanent',
      hilightedDate: this.state.date,
      max: new Date(),
      lang:
        lang === 'es'
          ? {
              days: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
              months: [
                'Enero',
                'Febrero',
                'Marzo',
                'Abril',
                'Mayo',
                'Junio',
                'Julio',
                'Agosto',
                'Septiembre',
                'Octubre',
                'Noviembre',
                'Deciembre'
              ],
              today: 'Hoy'
            }
          : {
              days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
              months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
              ],
              today: 'Today'
            },
      dayOffset: lang === 'es' ? 1 : 0
    })
    this.picker.on('select', (_, dp) =>
      this.setState({date: dp.state.selectedDate})
    )
  }

  componentWillUnmount() {
    this.picker.off()
  }

  componentWillUpdate(nextProps: Props, nextState: State) {
    if (this.state !== nextState) this.handleChange(nextState)
  }

  handleHourChange = (event: ChangeEvent<HTMLInputElement>) => {
    this.setState({hour: Number(event.target.value)})
  }

  handleMinutesChange = (event: ChangeEvent<HTMLInputElement>) => {
    this.setState({minutes: Number(event.target.value)})
  }

  handleClick = (event: KeyboardEvent<HTMLInputElement>) => {
    console.log('event.keyCode', event.charCode)
    if (this.props.onKeyPress)
      this.props.onKeyPress(event.charCode)
  }

  handleChange = (state: State) => {
    const {date, hour, minutes} = state
    date.setHours(hour)
    date.setMinutes(minutes)
    this.props.onChange(this.props.name, date)
  }

  ceros = (value: number) => {
    if (value > 9) {
      return String(value)
    }
    return '0'.concat(String(value))
  }

  render() {
    const {date, name, withTime, onChange, onKeyPress, ...props} = this.props
    const {hour, minutes} = this.state
    return (
      <div {...props}>
        <DatePicker id={this.id} />
        {withTime && (
          <TimePicker>
            <TimeInput>
              <Input
                type="number"
                label={'hora'}
                value={String(hour)}
                min={0}
                max={23}
                onKeyPress={this.handleClick}
                onChange={this.handleHourChange}
              />
            </TimeInput>
            <TimeInput>
              <Input
                type="number"
                label={'minutos'}
                value={String(minutes)}
                min={0}
                max={59}
                onKeyPress={this.handleClick}
                onChange={this.handleMinutesChange}
              />
            </TimeInput>
          </TimePicker>
        )}
      </div>
    )
  }
}

const DatePicker = cxs('div')({
  color: Theme.color.secondary,
  marginTop: Theme.size.space[1],
  ' .dp-cal-header': {
    fontSize: Theme.fontSize.big
  },
  ' .dp-cal .dp-selected, .dp-cal a:hover, .dp-cal a:focus': {
    color: Theme.color.primary
  },
  ' .dp-days a:focus, .dp-days a:hover, .dp-cal .dp-selected, .dp-years, .dp-months': {
    outline: `${Theme.size.hairline} solid ${Theme.color.hairline}`
  },
  ' .dp-col-header': {
    color: Theme.color.placeholder,
    borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`
  },
  ' .dp-cal-footer': {
    borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    [mediaQueries.desktop]: {
      borderBottom: 0
    }
  },
  ' .dp-edge-day, .dp-day-disabled': {
    color: Theme.color.hairline
  },
  [mediaQueries.desktop]: {
    outline: `${Theme.size.hairline} solid ${Theme.color.hairline}`
  }
} as CSSProperties)

const TimePicker = cxs('div')({
  padding: Theme.size.space[1],
  textAlign: 'center',
  borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  [mediaQueries.desktop]: {
    border: 0,
    outline: `${Theme.size.hairline} solid ${Theme.color.hairline}`
  }
} as CSSProperties)

const TimeInput = cxs('div')({
  width: '4em',
  margin: `0 ${Theme.size.space[1]}`,
  display: 'inline-block'
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/elements/DatePicker.tsx